import styleInject from '../../node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".AvatarImage-module_imageContainer__eIycQ img {\n  border-radius: 50%;\n  object-fit: cover;\n}\n.AvatarImage-module_imageContainer__eIycQ .AvatarImage-module_initialContainer__p6ydL {\n  background-color: #212121;\n  color: #ffffff;\n  text-transform: uppercase;\n  text-align: center;\n  font-size: 15px;\n  letter-spacing: 1px;\n  border-radius: 50%;\n}";
var Styles = {"imageContainer":"AvatarImage-module_imageContainer__eIycQ","initialContainer":"AvatarImage-module_initialContainer__p6ydL"};
styleInject(css_248z);

export { Styles as default };
//# sourceMappingURL=AvatarImage.module.scss.js.map
